var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ah-search-bar" }, [
    _c(
      "form",
      { on: { submit: _vm.onSubmit } },
      [
        _c("visually-hidden", [
          _c("label", { attrs: { for: _vm.id } }, [
            _vm._v("\n        " + _vm._s(_vm.inputLabel) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "ah-search-bar-input",
          attrs: {
            id: _vm.id,
            type: "text",
            placeholder: _vm.inputPlaceholder
          },
          domProps: { value: _vm.value }
        }),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "ah-search-bar-button", attrs: { type: "submit" } },
          [
            _c("visually-hidden", [
              _vm._v("\n        " + _vm._s(_vm.buttonLabel) + "\n      ")
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  width: "25",
                  height: "24",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("circle", {
                  attrs: {
                    cx: "9.85714",
                    cy: "9.85714",
                    r: "8.85714",
                    stroke: "black",
                    "stroke-width": "2"
                  }
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: {
                    x1: "16.9928",
                    y1: "16.4357",
                    x2: "23.8499",
                    y2: "23.2929",
                    stroke: "black",
                    "stroke-width": "2"
                  }
                })
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }